import { Component, OnInit } from '@angular/core';
import { KlixService } from '../services/klix.service';

@Component({
  selector: 'app-tarif',
  templateUrl: './tarif.component.html',
  styleUrls: ['./tarif.component.scss'],
  providers: [KlixService]
})
export class TarifComponent implements OnInit {
  tarifs: any[] = [];
  loading = true;

  constructor(private klixService: KlixService) { }

  ngOnInit() {
    this.klixService.getTarifs()
      .then(tarifs => {
        this.tarifs = tarifs;
        this.loading = false;
      })
      .catch(error => {
        console.error('Erreur chargement tarifs:', error);
        // Fallback avec tarifs par défaut
        this.tarifs = [
          { code: 'heure', label: 'Heure', price: 58, priceTTC: 70, description: '2 heures minimum' },
          { code: 'demi-journee', label: 'Demi-journée', price: 191, priceTTC: 230, description: 'De 8h30 à 13h ou de 13h30 à 18h' },
          { code: 'journee', label: 'Journée', price: 290, priceTTC: 348, description: 'De 8h30 à 18h' }
        ];
        this.loading = false;
      });
  }
}
